import { MessageCircle, Mail, CalendarClock, Clock, ShieldCheck, BadgePercent } from "lucide-react";
import { CONTACT, IMG } from "../data/site";
import { PageHero } from "../components/PageHero";
import { LeadForm } from "../components/LeadForm";
import { Seo, breadcrumbJsonLd } from "../components/Seo";
import { Reveal } from "../components/shared";
import { useI18n } from "../i18n/LanguageContext";

export default function ContactPage() {
  const { t } = useI18n();
  const cp = t.contactPage;
  const methods = [
    { icon: MessageCircle, label: cp.whatsapp, value: CONTACT.whatsapp, href: CONTACT.whatsappHref, testid: "contact-whatsapp", ext: true },
    { icon: Mail, label: cp.email, value: CONTACT.email, href: CONTACT.emailHref, testid: "contact-email", ext: false },
    { icon: CalendarClock, label: cp.bookCall, value: "calendly.com/offplandubai", href: CONTACT.calendly, testid: "contact-calendly", ext: true },
  ];
  const trust = [{ icon: BadgePercent, text: cp.t1 }, { icon: Clock, text: cp.t2 }, { icon: ShieldCheck, text: cp.t3 }];

  return (
    <div data-testid="contact-page">
      <Seo path="/contact" title={t.seo.contact.title} description={t.seo.contact.desc} image={IMG.night}
        jsonLd={breadcrumbJsonLd([{ name: t.crumbHome, path: "/" }, { name: cp.crumb, path: "/contact" }])} />
      <PageHero eyebrow={cp.eyebrow} crumb={cp.crumb} title={cp.title} sub={cp.sub} image={IMG.night} />

      <section className="py-16 sm:py-24">
        <div className="container-x grid gap-10 lg:grid-cols-[1fr_1.1fr]">
          <div>
            <div className="flex flex-col gap-4">
              {methods.map((m) => {
                const Icon = m.icon;
                return (
                  <a key={m.label} href={m.href} {...(m.ext ? { target: "_blank", rel: "noreferrer" } : {})} data-testid={m.testid}
                    className="group flex items-center gap-5 rounded-3xl bg-white p-6 shadow-soft transition-transform duration-300 hover:-translate-y-1">
                    <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-navy text-gold-300 transition-colors duration-300 group-hover:bg-gold group-hover:text-white"><Icon size={24} /></span>
                    <div><p className="text-xs uppercase tracking-wide text-muted">{m.label}</p><p className="mt-0.5 font-display text-lg font-semibold text-navy">{m.value}</p></div>
                  </a>
                );
              })}
            </div>
            <div className="mt-8 rounded-3xl bg-navy p-7">
              <h3 className="font-display text-xl font-semibold text-white">{cp.whyTitle}</h3>
              <ul className="mt-5 flex flex-col gap-4">
                {trust.map((tr) => {
                  const Icon = tr.icon;
                  return (
                    <li key={tr.text} className="flex items-center gap-3 text-white/85">
                      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-gold-300"><Icon size={17} /></span>
                      <span className="text-sm font-medium">{tr.text}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div>
            <Reveal><h2 className="font-display text-2xl font-semibold text-navy">{cp.formTitle}</h2><p className="mt-2 text-sm text-muted">{cp.formSub}</p></Reveal>
            <div className="mt-6"><LeadForm interest="General enquiry" /></div>
          </div>
        </div>
      </section>
    </div>
  );
}
